// extracted by mini-css-extract-plugin
module.exports = {"video-section":"k_q d-flex","video-section--header":"k_r","video-section__frame":"k_s ml-3"};